module.exports = __webpack_public_path__ + "media/assets/community/link-icon-821817a685c4c7c9762f770963dab1d93b1d8fd2d3c70e2b6b2c54df4b228588.png";